import React from 'react';
import {compose, mapProps} from 'recompose';
import _ from 'lodash';
import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {renderForError, renderWhileLoading} from 'App/util/recompose/graphql';
import {Card, CardBody, CardHeader} from 'reactstrap';
import ExportableTable from 'App/components/ExportableTable';
import PidChart from './PIDChart';
import CollapseBox from 'App/components/CollapseBox';

// @setupAccess([Role.superAdmin])
@compose(
  graphql(gql`
    {
      generals_pids_distributions {
        gene
        pid
        main_category_id
        main_category
        sub_category
        sub_category_id
        count
      }
    }`,
    {
      name: 'general_pid'
    }
  ),
  graphql(gql`
   query {
    pids_distributions(order:{column:"centre", direction: asc}) {
      gene
      pid
      main_category_id
      main_category
      sub_category
      sub_category_id
      count
      documenting_centre_id
      centre
      }
    }`,
    {
      name: 'center_pid'
    }
  ),
  mapProps(
    (ownerProps) => ({
      ...ownerProps,
      data: {
        ...ownerProps.general_pid,
        ...ownerProps.center_pid,
        error:
          ownerProps.center_pid.error ||
          ownerProps.general_pid.error,
        loading:
          ownerProps.center_pid.loading ||
          ownerProps.general_pid.loading,
      }
    })
  ),
  renderWhileLoading(),
  renderForError()
)
class PID extends React.Component {
  render() {
    const graphDataCentres = _(this.props.center_pid.pids_distributions)
      .groupBy('centre')
      .map((objs, key) => ({
          'centre': key,
          'series': objs,
        })
      )
      .value();

    const _groupedByCentres = _(this.props.center_pid.pids_distributions)
      .groupBy('centre');

    // format data for table:
    const tableDataCentres =
      _groupedByCentres
        .map((objs, key) => ({
          'centre': key,
          'tableData': objs.map(obj => ([obj.pid, obj.gene, obj.count])),
        }))
        .value();

    const mergedList = _.map(tableDataCentres, item =>
      (_.extend(item, _.find(graphDataCentres, {centre: item.centre})))
    );

    // format data for table:
    const tableDataGeneral = this.props.general_pid.generals_pids_distributions.map(
      obj => ([obj.pid, obj.gene, obj.count])
    );

    const tableHead = ['PID', 'gene', '#patient'];

    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>PID Diagnosis</CardHeader>
          <CardBody>
            <PidChart data={this.props.general_pid.generals_pids_distributions}
                      title={'PID main categories'}
                      subtitle={'ESID'}
                      id={'esid_chart'}
            />

            <CollapseBox title={'data table ( esid )'} isOpen={false}>
            <ExportableTable data={tableDataGeneral}
                             exportable={true}
                             id={'esid_table'}
                             head={tableHead}

            />
            </CollapseBox>
            {tableDataCentres.map(data => (
              <div key={data.centre + '_stats'}>
                <PidChart data={data.series}
                          subtitle={data.centre}
                          title={'Main categories'}
                          id={data.centre + '_chart'}
                />
                <CollapseBox title={'data table (' + data.centre + ')'} isOpen={false}>
                <ExportableTable data={data.tableData}
                                 exportable={true}
                                 id={data.centre + '_table'}
                                 head={tableHead}
                />
                </CollapseBox>
              </div>
            ))}
          </CardBody>
        </Card>
      </div>
    );
  }
};

export default PID;


// WEBPACK FOOTER //
// ./src/views/Statistics/PID/PID.js